import React, { useEffect, useState } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context';
import instance from '../../Utils/api'
import CircularProgress from '@mui/material/CircularProgress';
import Addstaff from '../components/Add_staff'
import ViewStaff from '../components/View_staff'
import Staffstatus from '../components/Staff_status'
import DownloadExportData from '../../Utils/excel'

const Staff = () => {
    const url = window.location.pathname;
    const authrole = localStorage.getItem('role');

    const columns = [
        { label: "S.No", field: "sno", },
        { label: "Full Name", field: "Name", },
        { label: "Phone Number", field: "phone", },
        { label: "Date of Joining", field: "DateofJoin", },
        { label: "Address", field: "Address", },
        { label: "Designation", field: "Designation", },
        { label: "Status", field: "Employeestatus", },
        ...(url === '/admin/Reports/Staff' || authrole === 'SeniorDesigner'
            ? []
            : [{ label: "Actions", field: "action", }])
    ];
    const title = {
        name: "Staff",
        subheading: "Follow up with the Staff",
        search: "Search Staff",
        ...(authrole === 'SeniorDesigner' ? {} : { button: 'Add Staff' })
    };
    const UserOptions = ['Active', 'Inactive'];
    const { loading, setLoading } = useGlobalContext();
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { openviewDialog, setopenviewDialog } = useGlobalContext();
    const { statusDialog, setstatusDialog } = useGlobalContext();
    const [openView, setOpenView] = useState(false);
    const [edit, setEdit] = useState(false);
    const [admins, setAdmins] = useState([]);
    const [employees, setEmployees] = useState(false)
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [totalpages, setTotalPages] = useState();
    const [currentPage, setCurrentPages] = useState(1);
    const [totalCount, setTotalcount] = useState();
    const [search, setSearch] = useState();
    const [userStatus, SetUserStatus] = useState();
    const [role, SetRole] = useState()
    const rowsperpage = 10;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectedstaff, setSelectedStaff] = useState();
    const [download, setDownload] = useState(false);

    const fetchadmins = async () => {
        const params = {
            search,
            page: currentPage,
            ...(!download ? { limit: rowsperpage } : { limit: totalpages * rowsperpage }),
            limit: rowsperpage,
            ...(userStatus && userStatus !== 'None' ? { Status: userStatus } : {}),
            download,
        }
        try {
            const response = await instance.get('/Staff/getStaff', { params });
            if (download) {
                DownloadExportData(response.data);
                setDownload(false);
            } else {
                const formatteddata = response?.data?.data?.map((employee, index) => ({
                    sno: index + 1,
                    staffId: employee?._id ? employee?._id : "---",
                    Name: employee?.Name ? employee?.Name : "---",
                    phone: employee?.Phone ? employee?.Phone : "---",
                    Alt_Phone: employee?.Alt_Phone ? employee?.Alt_Phone : "---",
                    Address: employee?.Address ? employee?.Address : "---",
                    DateofJoin: employee?.DateofJoin
                        ? new Date(employee.DateofJoin).toLocaleDateString("en-GB")
                        : "---",
                    Designation: employee?.Designation?.Designation ? employee?.Designation?.Designation : "---",
                    Employeestatus: employee?.Status === true ? "Active" : "Inactive",
                    allData: employee
                }))
                setAdmins(formatteddata);
                setTotalPages(response?.data?.totalPages);
                setCurrentPages(response?.data?.currentPage);
                setTotalcount(response?.data?.total);
            }
        }
        catch (error) {
            console.log("error to fetch admins:", error.message)
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchadmins(search, currentPage, rowsperpage,download, userStatus, role);
        setEmployees(false)
        setLoading(true);
    }, [employees, search, currentPage, rowsperpage,download])


    // Handle Row Click for Edit
    const handleEditClick = (employee) => {
        setSelectedEmployee(employee);
        setEdit(true);
        setOpenDialog(true);
    };


    const handleEmpolyeestatusClick = (employee) => {
        setSelectedEmployee(employee);
        setstatusDialog(true)
    }

    //filter function open menu
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Menu close handler
    const handleCloseFilter = () => {
        setAnchorEl(null);
    };

    const handleViewClick = (data) => {
        setOpenView(true);
        setSelectedStaff(data?.allData);
    }

    // Apply Filter Handler
    const handleEmployeeApplyFilter = () => {
        fetchadmins(search, currentPage, rowsperpage, false, userStatus, role);
        setAnchorEl(null);
    };

    const handleClearFilter = () => {
        SetUserStatus('')
        SetRole('');
        setSearch("");
        setCurrentPages(1);
        setEmployees(true)
        handleCloseFilter()
    }

    return (
        <>
            <Topbar />
            <section className='admin-catalogue'>
                <PageHeader
                    title={title}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    setSearch={setSearch}
                    files={true}
                    showButton={url === '/admin/Reports/Staff' ? false : true}
                    Download={() => setDownload(true)}
                />
                <SubHeader
                    isField={'employees'}
                    menu={false}
                    filter={true}
                    isVisible={true}
                    isEmployeepage={true}
                    anchorEl={anchorEl}
                    open={open}
                    handleClick={handleClick}
                    handleCloseFilter={handleCloseFilter}
                    handleEmployeeApplyFilter={handleEmployeeApplyFilter}
                    handleClearFilter={handleClearFilter}
                    UserOptions={UserOptions}
                    userStatus={userStatus}
                    SetUserStatus={SetUserStatus}
                    role={role}
                    SetRole={SetRole}
                />
                {loading ?
                    <div className='loader-section'>
                        <CircularProgress />
                    </div>
                    :
                    <CommonTable
                        columns={columns}
                        rows={admins}
                        openDialog={openDialog}
                        setOpenDialog={setOpenDialog}
                        openviewDialog={openviewDialog}
                        setopenviewDialog={setopenviewDialog}
                        edit={edit}
                        setEdit={setEdit}
                        handleEditClick={handleEditClick}
                        banner={true}
                        menu={true}
                        totalpages={totalpages}
                        rowsperpage={rowsperpage}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        setCurrentPages={setCurrentPages}
                        handleEmpolyeestatusClick={handleEmpolyeestatusClick}
                        handleViewClick={handleViewClick}
                    />
                }
                <Addstaff
                    edit={edit}
                    setEdit={setEdit}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    selectedEmployee={selectedEmployee}
                    setEmployees={setEmployees}
                />
                <ViewStaff
                    openDialog={openView}
                    setOpenDialog={setOpenView}
                    selectedstaff={selectedstaff}
                />
                <Staffstatus
                    statusDialog={statusDialog}
                    setstatusDialog={setstatusDialog}
                    selectedEmployee={selectedEmployee}
                    setEmployees={setEmployees}
                />
            </section>
        </>
    )
}


export default Staff